// extracted by mini-css-extract-plugin
export var centeredAd = "blog-post-module--centeredAd--JlplP";
export var hero = "blog-post-module--hero--isdhd";
export var post_header = "blog-post-module--post_header--hw-I5";
export var sectionFullwidth = "blog-post-module--sectionFullwidth--kZU43";
export var title = "blog-post-module--title--Ut5Jp";
export var toc = "blog-post-module--toc--l86v9";
export var toc_list = "blog-post-module--toc_list--ZeYu8";